import React, { useState, useEffect, useMemo } from "react";
import history from '../../history';
import Routes from '../../routes';
import {connect} from 'react-redux';
import axios from 'axios';
import './style.scss';
import {
  Elements,
  PaymentElement,
  ExpressCheckoutElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

import {setAuctionServerUpdate, setDealsServerUpdate, setRaffleServerUpdate, chargeAuctionWinPurchases} from "../../actions/products"
import {loadStripe} from '@stripe/stripe-js';
import CustomButton from '../../components/CustomButton';
import app from "../../base";
import {
  STRIPE_URL
} from '../../actions/const';
//import StripeCheckout from 'react-stripe-checkout';

//const stripePromise = loadStripe('pk_live_rBHqq8Hhajl1i3CsWRoBxD24');
const axiosStipe = axios.create({
    baseURL: STRIPE_URL,
    timeout: 10000,
    headers: {'Content-type':'application/json'}
});

function StripeCheckoutForm(props){
  const stripe = useStripe();
  const elements = useElements();






  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //return values 
  const [status, setStatus] = useState("default");
  const [intentId, setIntentId] = useState(null);

 /* const clientSecret = createCheckoutSessionInitialize("1", "1", "product description");
  console.log("HHHERERERERE", clientSecret);
  const options = {
    // passing the client secret obtained from the server
    clientSecret: sessionStorage[`clientSecret`], 
    };
*/

  //const [clientSecret, setClientSecret] = useState("hello");
  const {clientSecret, clientSecretCust,productOffer,setAuctionServerUpdate,setDealsServerUpdate,setRaffleServerUpdate, saveTokenToProduct} = props

  useEffect(() => {
    //const paymentEl = elements
    /*console.log("Elements on load: ", elements5);
    let elements1 = stripe.elements({clientSecret:clientSecret});
    const paymentElement = elements1.create("payment");
    paymentElement.mount("payment-element");
    console.log("ElementsP on load: ", elements1);
    console.log("PElement on load: ",paymentElement);*/

    //let payment_intent = stripe.retrievePaymentIntent(clientSecret);
    /*const { payment_intent } = async(e) => {
      await stripe.confirmPayment({clientSecret});
    }

     console.log(payment_intent);*/

    //createCheckoutSessionInitialize("1", "1", "product description")
    // Create PaymentIntent as soon as the page loads
      /*const bodyData = new FormData();

        bodyData.append("amount",1);
      

        axiosStipe.post('/paymentIntent', bodyData)
            .then((res) => {
                const {data} = res;
                if (res.status === 200) {

                    //let id = data['associated_objects'][0].id;
                    let clientSecret = data['client_secret'];
                    let clientSecret2 = data['clientSecret'];
                    console.log('----CLIENT SECRET', data);
                    setClientSecret(data.clientSecret)

                    //dispatch(attachpaymentMethod(paymentMethod, customerId, save, () => {history.push(Routes.bidReceived)}));

                    //dispatch(saveCustomer(customerId));
                }

            })
            .catch((error) => {
                console.log('Client Secret Error', error);
            });*/
 }, []); 
     


   /* fetch("https://staging-pn-stripe.herokuapp.com/paymentIntent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, []);*/

  const appearance = {
    theme: 'stripe',
  };

  const loader = 'always';
 /* const options = {
    loader: 'always',
    clientSecret: clientSecret,
    appearance: appearance,
    
  };*/


  //const loader = "auto"; 

  const handleSubmit = async (e) => {
    console.log("handleSubmit --  ");
    console.log("Payment elements elements: ", elements);
    e.preventDefault();

    console.log("Payment Elements elements: ", elements);

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    elements.submit();

    setIsLoading(true);

    let paymentElement = elements.getElement("payment");//(PaymentElement);
    console.log("Payment Elements: ", paymentElement);

    //let error;
    if (productOffer.type == 'auction'){
        const {error}  = await stripe.confirmSetup({
        elements,
        confirmParams: {  
          return_url: 'https://pownowapp.com/striple',
          payment_method_data: {
            billing_details: {
               name: app.auth().currentUser.name,
               email: `${app.auth().currentUser.phoneNumber}@pownowapp.com`
            }
          },
        },
        // Uncomment below if you only want redirect for redirect-based payments.
         redirect: 'if_required',
       });

        if (error) {
           
          if (error.type != error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
            } else {
            //setMessage("Payment Elements elements: ", elements);
            setMessage("An unexpected error occurred.");
           }
        } else {
        
         await stripe.retrieveSetupIntent(clientSecret ,).then(function(result){
               console.log("SETUP INTENT OBJ: ", result.setupIntent.payment_method);
               setAuctionServerUpdate(productOffer.id,productOffer.bid, result.setupIntent.payment_method)
      
          });
       
          //const setupIntent = await stripe.setupIntents.retrieve(clientSecret);
          //console.log("SETUP INTENT2 OBJ: ", setupIntent);
        
       
          history.push(Routes.bidReceived)
        }

        setIsLoading(false);
    } else {
        const {error}  = await stripe.confirmPayment({
        elements,
        confirmParams: {  
          return_url: 'https://pownowapp.com/striple',
          payment_method_data: {
            billing_details: {
               name: app.auth().currentUser.name,
               email: `${app.auth().currentUser.phoneNumber}@pownowapp.com`
            }
          },
        },
        // Uncomment below if you only want redirect for redirect-based payments.
         redirect: 'if_required',
      });

    if (error) {

      if (error.type != error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);

        } else {
        //setMessage("Payment Elements elements: ", elements);
        setMessage("An unexpected error occurred.");
       
        }
    } else {
      
      if (productOffer.type == 'raffle'){
            await stripe.retrievePaymentIntent(clientSecret ,).then(function(result){
               console.log("payment INTENT OBJ: ", result.paymentIntent.payment_method);
               console.log("ID:", productOffer.id);
               console.log("Quantity:",productOffer.quantity);
               setRaffleServerUpdate(productOffer.id,productOffer.bid, result.paymentIntent.payment_method)
               
          });
           // setRaffleServerUpdate(productOffer.id, productOffer.quantity, clientSecret)
          } 
      if (productOffer.type == 'deals') {
            await stripe.retrievePaymentIntent(clientSecret ,).then(function(result){
               console.log("payment INTENT OBJ: ", result.paymentIntent.payment_method);
               console.log("ID:", productOffer.id);
               console.log("Quantity:",productOffer.quantity);
               setDealsServerUpdate(productOffer.id, productOffer.bid, result.paymentIntent.payment_method)
            });
            //setDealsServerUpdate(productOffer.id, productOffer.quantity, clientSecret)
          }
      
        history.push(Routes.bidReceived)
    }

    setIsLoading(false);
   }

    

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.

  };

  const options = useMemo(() => {
    return {
        clientSecret: clientSecret,
    appearance: appearance,
    }
},[appearance,clientSecret])

  const paymentElementOptions = useMemo(() => {
    return {
    layout: "tabs",
    appearance :{
                  theme: 'flat',
                  variables: { colorPrimaryText: '#262626',
                               colorPrimary: '#01172e' }
                },
    emailRequired: false
        }
    },["tabs",appearance,false])

  const expressOptions = useMemo(() => {
    return {
    emailRequired: false
    }
  },[false])

  const onConfirm = async (e) => {

     console.log("Express Elements elements: ", elements);
    let expressElement = elements.getElement('expressCheckout');//(ExpressCheckoutElement);
    console.log("Express Element:", expressElement);

        if (productOffer.type == 'auction'){
        const {error}  = await stripe.confirmSetup({
        elements,
        confirmParams: {  
          return_url: 'https://pownowapp.com/striple',
          payment_method_data: {
            billing_details: {
               name: app.auth().currentUser.name,
               email: `${app.auth().currentUser.phoneNumber}@pownowapp.com`
            }
          },
        },
        // Uncomment below if you only want redirect for redirect-based payments.
         redirect: 'if_required',
       });

        if (error) {
           
          if (error.type != error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
            } else {
            //setMessage("Payment Elements elements: ", elements);
            setMessage("An unexpected error occurred.");
           }
        } else {
        
         await stripe.retrieveSetupIntent(clientSecret ,).then(function(result){
               console.log("SETUP INTENT OBJ: ", result.setupIntent.payment_method);
               setAuctionServerUpdate(productOffer.id,productOffer.bid, result.setupIntent.payment_method)
      
          });
       
          //const setupIntent = await stripe.setupIntents.retrieve(clientSecret);
          //console.log("SETUP INTENT2 OBJ: ", setupIntent);
        
       
          history.push(Routes.bidReceived)
        }

        setIsLoading(false);
    } else {

      const {error}  = await stripe.confirmPayment({
        elements,
        confirmParams: {  
          return_url: 'https://pownowapp.com/striple',
          payment_method_data: {
            billing_details: {
               name: app.auth().currentUser.name,
               email: `${app.auth().currentUser.phoneNumber}@pownowapp.com`
            }
          },
        },
        // Uncomment below if you only want redirect for redirect-based payments.
         redirect: 'if_required',
      });

    if (error) {

      if (error.type != error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);

        } else {
        //setMessage("Payment Elements elements: ", elements);
        setMessage("An unexpected error occurred.");
       
        }
    } else {
      
      if (productOffer.type == 'raffle'){
            await stripe.retrievePaymentIntent(clientSecret ,).then(function(result){
               console.log("payment INTENT OBJ: ", result.paymentIntent.payment_method);
               console.log("ID:", productOffer.id);
               console.log("Quantity:",productOffer.quantity);
               setRaffleServerUpdate(productOffer.id,productOffer.bid, result.paymentIntent.payment_method)
               
          });
           // setRaffleServerUpdate(productOffer.id, productOffer.quantity, clientSecret)
          } 
      if (productOffer.type == 'deals') {
            await stripe.retrievePaymentIntent(clientSecret ,).then(function(result){
               console.log("payment INTENT OBJ: ", result.paymentIntent.payment_method);
               console.log("ID:", productOffer.id);
               console.log("Quantity:",productOffer.quantity);
               setDealsServerUpdate(productOffer.id, productOffer.bid, result.paymentIntent.payment_method)
            });
            //setDealsServerUpdate(productOffer.id, productOffer.quantity, clientSecret)
          }
      
        history.push(Routes.bidReceived)
    }

    setIsLoading(false);
   }


    /*const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {  
        return_url: 'https://pownowapp.com/striple',
        payment_method_data: {
          billing_details: {
             name: app.auth().currentUser.name,
             email: `${app.auth().currentUser.phoneNumber}@pownowapp.com`
          }
        },
      },
      // Uncomment below if you only want redirect for redirect-based payments.
       redirect: 'if_required',
    });

     if (error) {

      if (error.type != error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
        } else {
        //setMessage("Payment Elements elements: ", elements);
        setMessage("An unexpected error occurred.");
       }
    } else {
      history.push(Routes.bidReceived)
    }*/
  };


  /*const paymentRequest = this.props.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Total',
        amount: (parseInt((parseFloat(amount) + parseFloat(amount * 0.05)).toFixed(2) * quantity * 100)  ),
      },
    });

  paymentRequest.canMakePayment().then((result) => {
      this.setState({canMakePayment: !!result});
    });*/
/*<Elements stripe={stripe} options={options}>
   </Elements>


     */
  return (
    <form id="payment-form" onSubmit={handleSubmit}  >
   
     <ExpressCheckoutElement
        id= "expressCheckout"
        options={expressOptions}
        onConfirm={onConfirm}
      />

      <PaymentElement id="payment-element" options={paymentElementOptions}/>
  

       <CustomButton
                            className = "submit"
                            id="submit"
                            disabled={isLoading || !stripe || !elements} 
                            text={isLoading ? <div className="spinner" id="spinner"></div> : productOffer.type =='auction' ? "Place Bid" : "Purchase"}
      />
      
      {message && <div id="payment-message">{message}</div>}
      
    </form>
  );
}


const mapStateToProps = ({login: {clientSecret}, login: {clientSecretCust}, products: {productOffer}}) => {
    return {
        clientSecret,
        clientSecretCust,
        productOffer
    }
};
//setAuctionServerUpdate, setDealsServerUpdate, setRaffleServerUpdate
/*    return {
        setAuctionServerUpdate: (...props) => {dispatch(setAuctionServerUpdate(...props))},
        setDealsServerUpdate: (...props) => {dispatch(setDealsServerUpdate(...props))},
        setRaffleServerUpdate: (...props) => {dispatch(setRaffleServerUpdate(...props))}
    }
};*/




const mapDispatchToProps = (dispatch) => {
  return {
        setAuctionServerUpdate: (...props) => {dispatch(setAuctionServerUpdate(...props))},
        setDealsServerUpdate: (...props) => {dispatch(setDealsServerUpdate(...props))},
        setRaffleServerUpdate: (...props) => {dispatch(setRaffleServerUpdate(...props))},
        chargeAuctionWinPurchases: (...props) => {dispatch(chargeAuctionWinPurchases(...props))}
    }
};


export default connect(mapStateToProps,mapDispatchToProps)(StripeCheckoutForm);



